// extracted by mini-css-extract-plugin
export default {"slideshow":"MobileBackgroundSlideshow_slideshow__CblLz","track":"MobileBackgroundSlideshow_track__hOpJc","slide":"MobileBackgroundSlideshow_slide__k41Za"};